import { GRAVITY_G, GRAVITY_MIN_DISTANCE } from "../constants";
import { isMovable, type Movable, type Planet } from "../entities";
import * as DMath from "../math/det-math";
import { wrappedAxisDelta } from "../math/torus";
import type { WorldState } from "../state";

/**
 * legacy: GravityStrategy.cpp. Only planets attract. Each movable object with mass
 * gains `G * M_planet / d^2` towards each planet per tick (independent of its own mass).
 * Classic ignores the world seam like the original; with `rules.wrapPhysics` each object is
 * pulled towards the nearest image of the planet on the torus.
 */
export function applyGravity(world: WorldState): void {
	const planets: Planet[] = [];
	const movables: Movable[] = [];
	for (const e of world.entities) {
		if (e.kind === "planet") planets.push(e);
		else if (isMovable(e) && e.mass !== 0) movables.push(e);
	}

	const { width, height } = world.size;
	const wrap = world.rules.wrapPhysics;
	for (const planet of planets) {
		for (const m of movables) {
			const dx = wrap ? wrappedAxisDelta(m.pos.x, planet.pos.x, width) : planet.pos.x - m.pos.x;
			const dy = wrap ? wrappedAxisDelta(m.pos.y, planet.pos.y, height) : planet.pos.y - m.pos.y;
			const dist = DMath.hypot(dx, dy);
			if (dist < GRAVITY_MIN_DISTANCE) continue;
			// a = G*M/d^2 along the unit vector (dx, dy)/d
			const k = (GRAVITY_G * planet.mass) / (dist * dist * dist);
			m.vel.x += dx * k;
			m.vel.y += dy * k;
		}
	}
}
